<template>
    <v-container fluid>
    <h2 class="text-h4">{{$t('campaigns.detail.title')}}</h2>
    <template v-if="item">
    <v-card id="pfid1619047636" class="mt-3">
      <v-row no-gutters>
        <v-col cols="12" md="6" lg="4" xl="3">
        <v-card-title>{{$t('campaigns.detail.basicInfo')}}</v-card-title>
            <v-list subheader>
              <v-list-item>
                <v-list-item-icon><v-icon>$rename</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('common.name')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>{{ typeIcon }}</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.mediumAndType.type')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ campaignType }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>{{ mediumIcon }}</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.mediumAndType.medium')}}</v-list-item-subtitle>
                  <v-list-item-title>E-mail</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="isScheduled">
                <v-list-item-icon><v-icon>$calendarFrom</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.summary.plan.start')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ sendStart }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="isAutomatic">
                <v-list-item-icon><v-icon>$messageFrequency</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.summary.plan.frequency')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ frequency }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="isBTC || isWelcome">
                <v-list-item-icon><v-icon>$messageDelay</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.summary.plan.delay')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ delay }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <template v-if="!isSWU">
          <v-card-title>{{$t('campaigns.segment.title')}}</v-card-title>
            <v-list subheader>
              <v-list-item>
                <v-list-item-icon><v-icon>$settings</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.segment.setup')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ segment }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="!isAllSegment && !isTag">
                <v-list-item-icon><v-icon>$segmentFrom</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('common.intervals.from')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.segment.from }} {{ segmentSuffix }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item  v-if="!isAllSegment && !isTag">
                <v-list-item-icon><v-icon>$segmentTo</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('common.intervals.to')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.segment.to }} {{ segmentSuffix }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="!isAllSegment  && !isTag">
                <v-list-item-icon><v-icon>$calendarChoose</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.segment.evaluationPeriod.title')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.evaluationPeriod.window ? evaluationWindow : evaluationPeriod }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
               <v-list-item v-if="isTag">
                <v-list-item-icon><v-icon>$tag</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.segment.tag.title')}}</v-list-item-subtitle>
                  <v-list-item-title>{{item.segment.inverse ? $t('campaigns.segment.tag.inversePrefix') : ''}} {{ segmentTag }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
          <template v-else>
             <v-card-title>{{$t('campaigns.segment.swu.title')}}</v-card-title>
            <v-list subheader>
              <v-list-item v-if="!isAllSegment">
                <v-list-item-icon><v-icon>$segment</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.segment.swu.count')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.segment.count }} {{ $t('dashboard.messages.suffix') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="!isAllSegment">
                <v-list-item-icon><v-icon>$calendarChoose</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.segment.swu.length')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.segment.duration }} {{ $t('dashboard.swu.days') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-card-title>{{$t('campaigns.setup.message.title')}}</v-card-title>
            <v-list subheader>
              <v-list-item>
                <v-list-item-icon><v-icon>$mailing</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.setup.sender.email')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ `${item.from}@${item.domain.dnsName}` }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$rename</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.setup.sender.name')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.friendlyFrom }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$mailing</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.setup.sender.replyTo')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.replyTo ? `${item.replyTo}@${item.domain.dnsName}` : $t('common.notSet') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$ganalytics</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.setup.message.utmCampaign')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.utm.campaign }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-card-title>{{$t('campaigns.detail.stats.title')}}</v-card-title>
          <v-list subheader>
              <v-list-item>
                <v-list-item-icon><v-icon color="primary">$sentTotal</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.detail.stats.sent')}}</v-list-item-subtitle>
                  <v-list-item-title><span class="primary--text">{{ totalSent }}</span></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$unsubscribed</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.detail.unsubscribes.title')}}</v-list-item-subtitle>
                  <v-list-item-title><span>{{ unsubscribesRate }}% ({{ unsubscribes}})</span></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$refreshed</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('campaigns.detail.stats.updated')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ formatDate(statsUpdate) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$calendarFrom</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-select id="pfid1619047654" dense v-model="period" :items="periods" @change="loadStats(false)" append-outer-icon="$refresh" @click:append-outer="loadStats(false)"/>
                </v-list-item-content>
              </v-list-item>
          </v-list>
            <!--
           <v-card-actions>
             <v-btn id="pfid1619047647" :loading="loading" text color="primary" @click="loadStats(false)"><v-icon left>$refresh</v-icon>{{$t('common.refresh')}}</v-btn>
           </v-card-actions>
           -->   
        </v-col>
        </v-row>
    </v-card>
    <v-row>
    <v-col cols="12" v-if="!isSWU">
      <sales-card
        id="pfid1619273859"
        dark 
        :height="380"
        :chart-height="180"
        :label="$t('dashboard.sales.all')"
        :value="sales"
        :value-count="orderCount"
        :count-suffix="$t('dashboard.orders.suffix')"
        :currency="item.domain.currency"
        :loading="loading"
        :xaxis="xaxis"
        :series="salesDays"
      />
    </v-col>
     <v-col cols="12" v-else>
      <sent-card
        id="pfid1643385291" 
        dark 
        :height="380"
        :chart-height="180"
        :label="$t('campaigns.detail.stats.sent')"
        :value="totalSent"
        :suffix="$t('dashboard.messages.suffix')"
        :loading="loading"
        :xaxis="xaxis"
        :series="sentDays"
      />
    </v-col>
    <v-col cols="12" lg="6">
    <rate-card
      id="pfid1619047663" 
      :height="280"
      :chart-height="80"
      :label="$t('campaigns.detail.openRate.series.title')"
      :value="openRate"
      :value-count="openCount"
      :count-suffix="$t('campaigns.detail.openRate.series.suffix')"
      :loading="loading"
      :xaxis="xaxis"
      :series="openRateDays"
     />
    </v-col>
     <v-col cols="12" lg="6">
     <rate-card
      id="pfid1619047669" 
      :height="280"
      :chart-height="80"
      :label="$t('campaigns.detail.clickRate.series.title')"
      :value="clickRate"
      :value-count="clickCount"
      :count-suffix="$t('campaigns.detail.clickRate.series.suffix')"
      :loading="loading"
      :xaxis="xaxis"
      :series="clickRateDays"
     />
    </v-col>
    <v-col cols="12" lg="6">
      <sources-card 
        style="height: 400px"
        :loading="loading" 
        id="pfid1619047678" 
        :label="$t('campaigns.detail.interactions.title')" 
        :data="interactions" />
    </v-col>
    <v-col cols="12" lg="6">
      <heatmap-card 
        style="height: 400px"
        :loading="loading" 
        id="pfid1619049634" 
        :label="$t('campaigns.detail.activity.title')" 
        :series="activity" />
    </v-col>
    <v-col v-if="legacy" cols="12" lg="6">
      <v-card
      class="fill-height"
      id="pfid1619086243">
        <v-card-title>{{ $t('campaigns.summary.preview.title') }}</v-card-title>
      <campaign-preview :html="preview" :height="500" :columns="$vuetify.breakpoint.lgAndUp ? 2 : 1" />
      <v-card-actions>
        <!--
        <v-menu v-if="item.templateSES" offset-y top :close-on-content-click="false" v-model="previewMenu">
        <template v-slot:activator="{ on, attrs }">
        <v-btn id="pfid1619086228"  :loading="sending" color="primary" text v-on="on" v-bind="attrs"><v-icon left>$send</v-icon>{{$t('campaigns.summary.preview.send')}}</v-btn>
        </template>
        <v-card style="width:300px">
          <v-card-title>{{$t('campaigns.summary.preview.recipient')}}</v-card-title>
          <v-card-text>
            <v-text-field
            id="pfid1619086822" 
            v-model="recipient"
            append-outer-icon="$send"
            @click:append-outer="sendPreview"
            />
          </v-card-text>
        </v-card>
        </v-menu>
        -->
        <campaign-preview-sender v-if="item.templateSES" :campaign="item.id" />
        <v-btn v-else disabled text>{{ $t('campaigns.summary.preview.disabled') }}</v-btn>
      </v-card-actions>
      </v-card>
    </v-col>
    <v-col v-if="legacy" cols="12" lg="6">
      <v-card class="fill-height">
            <v-card-title>{{$t('campaigns.detail.subjectRates.title')}}</v-card-title>
            <v-list subheader>
              <v-list-item v-for="(s,i) in subjectRates" :key="i">
                <v-list-item-icon><v-icon>{{ subjectIcon(i) }}</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ s.title }}</v-list-item-title>
                  <v-list-item-subtitle>{{ s.rate }}%</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
      </v-card>
    </v-col>
    <v-col v-if="!legacy" cols="12">
      <v-card class="fill-height">
      <v-card-title>{{$t('campaigns.detail.variants.title')}}</v-card-title>  
      <v-data-table 
        :headers="variantHeaders" 
        :items="variantStats"
        show-expand
        :items-per-page="-1"
        :expanded.sync="variantsExpanded"
      >
        <template v-slot:[`item.variant`]="i">
          <v-icon :color="getVariantColor(i.item.id)">{{ `$campaignVariant${i.item.name}` }}</v-icon>
        </template>
        <template v-slot:[`item.preview`]="i">
          <campaign-preview-sender v-if="['WAITING', 'COMPUTING','SENDING'].includes(item.state)" :campaign="item.id" :variant="i.item.id" />
        </template>
        <template #expanded-item="i">
          <td colspan="7" class="text-center pa-3">
          <v-progress-circular v-if="previewsLoading > 0 && !variantsPreview[i.item.id]"
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
          <campaign-preview v-else :html="variantsPreview[i.item.id]" :height="500" :columns="1" />
          
          

          </td>
        </template>
      </v-data-table>
      </v-card>
    </v-col>
    <!--
      <v-col cols="4" lg="2">
      <v-card class="fill-height">
            <v-card-title>{{$t('campaigns.detail.unsubscribes.title')}}</v-card-title>
            <v-card-text>{{ unsubscribesRate }}% ({{ unsubscribes}})</v-card-text>
      </v-card>
    </v-col>
    -->


    </v-row>
    </template>
    <v-skeleton-loader v-else type="card" />
    </v-container>
</template>
<script>

import Timezones from '@/mixins/timezones'
import CampaignFormatters from '@/mixins/campaign-formatters'
import SalesCard from '@/components/dashboard/SalesCard'
import SentCard from '@/components/dashboard/SentCard'
import RateCard from '@/components/dashboard/RateCard'
import SourcesCard from '@/components/dashboard/SourcesCard'
import HeatmapCard from '@/components/dashboard/HeatmapCard'
import CampaignPreview from '@/components/CampaignPreview'
import Formatters from '@/mixins/formatters'
import { mapState } from 'vuex'
import CampaignPreviewSender from '@/components/CampaignPreviewSender.vue'

export default {
  name: 'CampaignDetail',
  mixins: [Formatters, CampaignFormatters, Timezones],
  components: { SalesCard, SentCard, RateCard, SourcesCard, HeatmapCard, CampaignPreview, CampaignPreviewSender },
  data() {
    return {
      loading: false,
      //sending: false,
      //previewMenu: false,
      //recipient: this.$store.getters['auth/email'],
      period: '7d',
      periods: ['7d','14d','21d','1m','3m','6m','12m'].map(p => { return { text: this.$t(`common.periods.${p}`), value: p}}),
      variantsExpanded: [],
      variantsPreview: {},
      previewsLoading: 0,
      variantHeaders: [
        { value: 'variant', text: this.$t('campaigns.detail.variants.variant') },
        { value: 'subject', text: this.$t('campaigns.setup.subjects.label') },
        { value: 'sent', text: this.$t('campaigns.detail.stats.sent') },
        { value: 'openRate', text: this.$t('campaigns.detail.openRate.series.title') },
        { value: 'clickRate', text: this.$t('campaigns.detail.clickRate.series.title') },
        { value: 'data-table-expand', text: this.$t('campaigns.detail.variants.design'),  },
        { value: 'preview', text: this.$t('campaigns.summary.preview.title') },
      ]
      
    };
  },
  computed: {
      legacy() {
        return this.item?.subjects?.length > 0;
      },
      frequency() {
        return this.frequencies.find(d => d.value == this.item?.schedule.frequency)?.text || this.$t('common.notSet');
      },
      delay() {
        return this.delays.find(d => d.value == this.item?.schedule.delay)?.text || this.$t('common.notSet');
      },
      statsUpdate() {
        return this.itemStats?.updated;
      },
      xaxis() {
        if(!this.itemStats) {
          return null;
        }
        return {
          type: 'datetime',
          categories: this.itemStats.data.dayRates.map(r => `${r.category}T00:00:00.000Z`)
        }
      },
      totalSent() {
        return this.itemStats?.data.globalRates.sent;
      },
      openRate() {
        return this.itemStats?.data.globalRates.sent ? ((this.itemStats?.data.globalRates.opened / this.itemStats?.data.globalRates.sent) * 100) : 0;
      },
      openCount() {
        return this.itemStats?.data.globalRates.opened
      },
      openRateDays() {
        return [
          {
            name: this.$t('campaigns.detail.openRate.series.title'),
            data: this.itemStats?.data.dayRates.map(r => r.sent ? ((r.opened / r.sent) * 100) : 0)
          },
          {
            name: this.$t('campaigns.detail.openRate.series.messages'),
            data: this.itemStats?.data.dayRates.map(r => r.opened)
          }
        ]
      },
      clickRate() {
        return this.itemStats?.data.globalRates.sent ? ((this.itemStats?.data.globalRates.clicked / this.itemStats?.data.globalRates.sent) * 100) : 0;
      },
      clickCount() {
        return this.itemStats?.data.globalRates.clicked
      },
      clickRateDays() {
        return [
          {
            name: this.$t('campaigns.detail.clickRate.series.title'),
            data: this.itemStats?.data.dayRates.map(r => r.sent ? ((r.clicked / r.sent) * 100) : 0)
          },
          {
            name: this.$t('campaigns.detail.clickRate.series.messages'),
            data: this.itemStats?.data.dayRates.map(r => r.clicked)
          }
        ]
      },
      interactions() {
        return [
          { title: this.$t('campaigns.detail.interactions.unopened'), 
          value: this.itemStats?.data.globalRates.sent - this.itemStats?.data.globalRates.opened - this.itemStats?.data.globalRates.clicked, 
          color: this.$vuetify.theme.themes.light.error },
          { title: this.$t('campaigns.detail.interactions.opened'), 
          value: this.itemStats?.data.globalRates.opened - this.itemStats?.data.globalRates.clicked, 
          color:this.$vuetify.theme.themes.light.info}, 
          { title: this.$t('campaigns.detail.interactions.clicked'), 
          value: this.itemStats?.data.globalRates.clicked, 
          color:this.$vuetify.theme.themes.light.success},  
        ]
      },
      activity() {
        if(!this.itemStats?.data.heatmap) {
          return null;
        }
        let days = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
        let day = this.item.domain.firstDayOfWeek || 0;
        let series = [];
        do {
          //console.debug(`day ${day} fdw ${this.item.domain.firstDayOfWeek} common.days.${days[day]}`);
          series.push({
            name: this.$t(`common.days.${days[day]}`),
            data: this.itemStats?.data.heatmap[days[day]].map((a,i) => { return { x: `${i}`, y: a}})
          })
          day = (day+1) % 7;
          
        } while(day != this.item.domain.firstDayOfWeek)
        
        return series.reverse();
      },
      unsubscribes() {
        return this.itemStats?.data.unsubscribes;
      },
      unsubscribesRate() {
        if(!this.itemStats?.data.globalRates.sent) {
          return 0;
        }
        return ((this.itemStats?.data.unsubscribes / this.itemStats?.data.globalRates.sent) * 100).toFixed(2);
      },
      subjectRates() {
        return this.itemStats?.data.subjectRates?.map(sr => { return { title: sr.category, rate: sr.sent ? ((sr.opened / sr.sent) * 100).toFixed(2) : 0 }}) || [];

      },
      sales() {
        return this.itemStats?.data.globalSales.sales;
      },
      orderCount() {
        return this.itemStats?.data.globalSales.orders;
      },
      salesDays() {
        return [
          {
            name: this.$t('dashboard.sales.all'),
            data: this.itemStats?.data.daySales.map(r => r.sales)
          },
          {
            name: this.$t('dashboard.orders.title'),
            data: this.itemStats?.data.daySales.map(r => r.orders)
          }
        ]
      },
      sentDays() {
        return [
          {
            name: this.$t('campaigns.detail.stats.sent'),
            data: this.itemStats?.data.dayRates.map(r => r.sent || 0)
          }
        ]
      },
      variantStats() {
        return this.itemStats?.data.variantRates?.map(vr => { 
          let variant = this.item?.variants?.find(v => v.id == vr.category);
          let name = variant?.name ?? '';
          let subject = variant.subject;
          return { 
            name,
            subject,
            id: vr.category,
            sent: vr.sent,
            templateSES: variant.templateSES,
            openRate: vr.sent ? ((vr.opened / vr.sent) * 100).toFixed(2) : 0,
            clickRate: vr.sent ? ((vr.clicked / vr.sent) * 100).toFixed(2) : 0,
          }
        }).sort((a,b) => a.name.localeCompare(b.name)) || [];
      },
      ...mapState('campaigns', ['item', 'itemStats', 'preview']),
      ...mapState('contacts', ['tags'])
      //...mapGetters('campaigns', [])
  },
  watch: {
    item() {
      
      if(this.item) {
        //console.debug('Loading stats - watch');
        //console.dir(val);
        this.prepare();
      }
    },
    async variantsExpanded(val, oldVal) {
      console.debug('Expanded!', val, oldVal)
      val.forEach(async v => {
        // we want to load only the newly added - if user rapidly open all the variants, this will be triggered multiple times and the api calls might not be finished yet
        if(!oldVal.find(ov => ov.id == v.id) && !this.variantsPreview[v.id]) {
          // rhis is here to have just a simple variable that is reactive
          this.previewsLoading += 1;
          console.debug('Getting variant preview');
          this.variantsPreview[v.id] = (await this.$store.dispatch('variants/get', {id: v.id, noStore: true})).preview;
          this.previewsLoading -= 1;
        }
      });
    }
  },
  methods: {
    getVariantColor(id) {
      return this.item?.variants?.find(v => v.id == id)?.active ? 'success' : 'grey';
    },
    loadStats(allowCache) {
      if(this.item) {
        this.loading = true;
        this.$store.dispatch('campaigns/getStats', { id: this.item.id, period: this.period, allowCache}).then(() => {
          this.loading = false;
        })
      }
    },
    setPeriodSelect() {
      if(this.item.scheduleType =='SCHEDULED') {
        this.periods = [{ text: this.$t(`common.periods.all`), value: 'all'}]
        this.period = 'all';
      }
    },
    /*
    async sendPreview() {
        this.sending = true;
        this.previewMenu = false;
        let success = await this.$store.dispatch('campaigns/sendTestEmail', {email: this.recipient, campaignID: this.item.id});
        this.sending = false;
        this.$store.dispatch('ui/notify', { error: !success, text: success ? this.$t('campaigns.notify.previewSent') : this.$t('campaigns.notify.previewError')});
    },
    */
    prepare() {
      this.setPeriodSelect();
      if(!this.itemStats) {
        this.loadStats(true);
      }
      if(this.isTag) {
        this.$store.dispatch("contacts/listTags", { domainID: this.item.domainID });
      }
      // this could make the object somewhat reactive
      this.item.variants.forEach(v => this.variantsPreview[v.id] = null);
      
    }
  },
  created() {
    if(this.item) {
      console.debug('Loading stats - create');
      this.prepare();
    }
  },
};
</script>